module.exports = __webpack_public_path__ + "static/img/sdwyj_img3.fe88b2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sdwyj_img3.png
// module id = 94Y/
// module chunks = 1